"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
require("core-js");
require("./index.scss");
require("~@/widget/drag/drag.scss");
var React = require("react");
var ReactDom = require("react-dom");
var nav_1 = require("~@/widget/nav/nav");
var right_download_1 = require("~@/widget/right-download/right-download");
var right_history_1 = require("~@/widget/right-history/right-history");
var right_follow_1 = require("~@/widget/right-follow/right-follow");
var right_userinfo_1 = require("~@/widget/right-userinfo/right-userinfo");
var search_1 = require("~@/widget/search/search");
var theme_1 = require("~@/widget/theme/theme");
var stat_1 = require("~@/widget/stat/stat");
var user_1 = require("~/js/lib/user/user");
var util_1 = require("~/js/lib/util/util");
var then_ajax_1 = require("then-ajax");
var right_anchor_1 = require("src/components/widget/right-anchor/right-anchor");
var right_guild_1 = require("src/components/widget/right-guild/right-guild");
var version = require('~/../package.json').version;
var SLT = {
    HEADER: '#wHead'
};
var INTERFACE = {
    HEADER_INFO: theme_1.DOMAIN + "/yyweb/module/data/header"
};
var cache = {
    firstScreenLoaded: false,
    firstScreenLoadedFns: [],
    onLogStateChangeFns: [],
    visibilitychangeHandle: undefined
};
var themeInfo;
var IS_REBUILD;
var handle;
var App = (function (_super) {
    __extends(App, _super);
    function App(props) {
        var _this = _super.call(this, props) || this;
        _this.downloadRef = React.createRef();
        _this.state = {
            themeInfo: themeInfo,
            rebuild: IS_REBUILD,
            catalogs: [],
            hotkey: '',
            isLogined: user_1.user.isLoginSync(),
            userInfo: {
                logo: theme_1.DEFAULT_AVATAR,
                nick: '',
                uid: 0,
                isGuild: false
            }
        };
        window.header.onLogStateChange(function () {
            _this.setState({
                isLogined: user_1.user.isLoginSync()
            }, function () {
                _this.updateUserInfo();
            });
        });
        handle = _this;
        return _this;
    }
    App.prototype.render = function () {
        var _a = this.state, themeInfo = _a.themeInfo, rebuild = _a.rebuild, catalogs = _a.catalogs, hotkey = _a.hotkey, userInfo = _a.userInfo, isLogined = _a.isLogined;
        var headerClasses = themeInfo.headerClasses, homePage = themeInfo.homePage;
        var _b = this, login = _b.login, logout = _b.logout, reg = _b.reg, updateUserInfo = _b.updateUserInfo;
        return (React.createElement("div", { className: rebuild ? '' : "p-header " + headerClasses.join(' '), id: rebuild ? '' : SLT.HEADER },
            React.createElement("div", { className: "p-header__child" },
                React.createElement("div", { className: "p-header__main" },
                    React.createElement("div", { className: "p-header__main__cnt" },
                        React.createElement("h1", null,
                            React.createElement("a", { className: "p-header__logo", href: homePage, title: "YY\u76F4\u64AD-YY LIVE-\u5168\u6C11\u5A31\u4E50\u89C6\u9891\u76F4\u64AD\u5E73\u53F0", onClick: function () { return stat_1.stat(stat_1.EStatType.LOGO_CLICK); } })),
                        React.createElement("div", { className: "p-header__back" },
                            React.createElement("a", { className: "p-header__back__link", href: homePage, onClick: function () { return stat_1.stat(stat_1.EStatType.BACK_CLICK); } }, "\u9996\u9875")),
                        React.createElement(nav_1.Nav, { catalogs: catalogs }),
                        React.createElement(search_1.Search, { themeInfo: themeInfo, hotkey: hotkey }),
                        React.createElement("div", { className: "p-header__main__cnt__right" },
                            React.createElement(right_userinfo_1.RightUserinfo, { isLogined: isLogined, userInfo: userInfo, login: login, logout: logout, reg: reg }),
                            React.createElement(right_follow_1.RightFollow, { themeInfo: themeInfo, userInfo: userInfo, isLogined: isLogined }),
                            React.createElement(right_history_1.RightHistory, { userInfo: userInfo, isLogined: isLogined, login: login, ref: this.downloadRef }),
                            React.createElement(right_anchor_1["default"], null),
                            React.createElement(right_guild_1["default"], null),
                            React.createElement(right_download_1.RightDownload, { themeInfo: themeInfo })))))));
    };
    App.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var isLogined;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        isLogined = this.state.isLogined;
                        return [4, this.fetchHeaderInfo()];
                    case 1:
                        _a.sent();
                        if (!isLogined) return [3, 4];
                        return [4, this.fetchUserInfo()];
                    case 2:
                        _a.sent();
                        return [4, this.fetchUserType()];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        cache.visibilitychangeHandle = function () {
                            var currentUid = user_1.user.getUidSync() || false;
                            if (currentUid !== _this.state.isLogined) {
                                header.logStateChange();
                            }
                        };
                        window.addEventListener('focus', cache.visibilitychangeHandle);
                        return [2];
                }
            });
        });
    };
    App.prototype.componentWillUnmount = function () {
        window.removeEventListener('focus', cache.visibilitychangeHandle);
    };
    App.prototype.fetchHeaderInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var rs, categoryTabs, brief;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, then_ajax_1.thenGet(INTERFACE.HEADER_INFO)];
                    case 1:
                        rs = _a.sent();
                        categoryTabs = rs.categoryTabs, brief = rs.brief;
                        this.setState({
                            catalogs: categoryTabs,
                            hotkey: brief
                        });
                        return [2];
                }
            });
        });
    };
    App.prototype.fetchUserInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var timeStart, _a, err, info;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        timeStart = +new Date();
                        return [4, user_1.user.fetchUserInfo()];
                    case 1:
                        _a = _b.sent(), err = _a[0], info = _a[1];
                        if (err) {
                            if (err.code === -1) {
                                this.resetUserInfo();
                            }
                        }
                        else {
                            if (info.logo) {
                                info.logo = util_1.convertHttps(info.logo);
                            }
                            if (info.hdLogo) {
                                info.hdLogo = util_1.convertHttps(info.hdLogo);
                            }
                            this.setState({
                                userInfo: __assign(__assign({}, this.state.userInfo), info)
                            });
                        }
                        stat_1.metrics(stat_1.EMetricsType.USERCAR_FETCH_USER_INFO, {
                            code: err ? err.code : 0,
                            cost: +new Date() - timeStart
                        });
                        return [2];
                }
            });
        });
    };
    App.prototype.fetchUserType = function () {
        return __awaiter(this, void 0, void 0, function () {
            var isGuild;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, user_1.user.isGuild()];
                    case 1:
                        isGuild = _a.sent();
                        this.setState({
                            userInfo: __assign(__assign({}, this.state.userInfo), { isGuild: isGuild })
                        });
                        return [2];
                }
            });
        });
    };
    App.prototype.resetUserInfo = function () {
        this.setState({
            isLogined: false,
            userInfo: {
                logo: theme_1.DEFAULT_AVATAR,
                nick: '',
                uid: 0
            }
        });
    };
    App.prototype.login = function (next) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, user_1.user.showYYLoginBox(next)];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        });
    };
    App.prototype.logout = function (next) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, user_1.user.logout()];
                    case 1:
                        _a.sent();
                        if (next) {
                            next();
                        }
                        return [2];
                }
            });
        });
    };
    App.prototype.reg = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, user_1.user.showYYRegBox()];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        });
    };
    App.prototype.updateUserInfo = function (next) {
        var isLogined = this.state.isLogined;
        if (isLogined) {
            this.fetchUserInfo()["catch"](function () { return undefined; });
        }
        else {
            this.resetUserInfo();
        }
    };
    return App;
}(React.Component));
var header = function (op) {
    if (op === void 0) { op = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var iCtx, iTarget;
        return __generator(this, function (_a) {
            themeInfo = theme_1.theme(op);
            iCtx = themeInfo.target || window.LOADER_PARENT_EL || SLT.HEADER;
            if (typeof iCtx === 'string') {
                iTarget = document.querySelector(iCtx);
            }
            else {
                iTarget = iCtx;
            }
            if (!iTarget) {
                throw new Error("header() run error, op.target is not exists " + iCtx);
            }
            IS_REBUILD = iCtx === SLT.HEADER;
            if (IS_REBUILD) {
                iTarget.className = iTarget.className + " " + themeInfo.headerClasses.join(' ');
            }
            if (handle) {
                handle.setState({
                    themeInfo: themeInfo
                });
            }
            else {
                ReactDom.render(React.createElement(App, null), iTarget);
            }
            return [2];
        });
    });
};
header.resize = function (fn) {
    window.addEventListener('resize', function () {
        var w = document.body.scrollWidth;
        if (fn) {
            fn(w);
        }
    });
};
header.onresize = function (fn) {
    window.addEventListener('resize', function () {
        var w = document.body.scrollWidth;
        fn(w);
    });
};
header.onLogStateChange = function (fn) {
    cache.onLogStateChangeFns.push(fn);
};
header.logStateChange = function () {
    if (window.header.loginNoRefresh || cache.onLogStateChangeFns.length > 1) {
        var isLogin_1 = user_1.user.isLoginSync();
        cache.onLogStateChangeFns.forEach(function (fn) {
            fn(isLogin_1);
        });
    }
    else {
        window.location.reload();
    }
};
header.loginNoRefresh = false;
header.ref = (function () {
    var iRef = util_1.getParameterByName('f');
    var LOCAL_NAME = 'shareform';
    if (iRef) {
        util_1.localStorage.setItem(LOCAL_NAME, iRef);
    }
    else {
        iRef = util_1.localStorage.getItem(LOCAL_NAME) || '0';
    }
    return iRef;
})();
header.cpuid = (function () {
    var iRef = util_1.getParameterByName('cpuid');
    var LOCAL_NAME = 'cpuid';
    if (iRef) {
        util_1.localStorage.setItem(LOCAL_NAME, iRef);
    }
    else {
        iRef = util_1.localStorage.getItem(LOCAL_NAME) || '0';
    }
    return iRef;
})();
header.pcuid = header.cpuid;
header.history = {
    init: function (op) {
        return __awaiter(this, void 0, void 0, function () {
            var r;
            return __generator(this, function (_a) {
                if (handle) {
                    r = handle.downloadRef.current.add(op);
                    return [2, r];
                }
                else {
                    return [2];
                }
                return [2];
            });
        });
    }
};
header.version = version;
function firstScreenLoaded() {
    if (cache.firstScreenLoaded) {
        return;
    }
    cache.firstScreenLoaded = true;
    cache.firstScreenLoadedFns.forEach(function (fn) {
        fn();
    });
    cache.firstScreenLoadedFns.length = 0;
}
function onFirstScreenLoaded(fn) {
    if (cache.firstScreenLoaded) {
        fn();
    }
    else {
        cache.firstScreenLoadedFns.push(fn);
    }
}
setTimeout(function () {
    if (!cache.firstScreenLoaded) {
        firstScreenLoaded();
    }
}, 3000);
window.header = header;
window.user = user_1.user;
window.firstScreenLoaded = firstScreenLoaded;
window.onFirstScreenLoaded = onFirstScreenLoaded;
window.YY_COMMON = {
    header: header,
    user: user_1.user,
    firstScreenLoaded: firstScreenLoaded,
    onFirstScreenLoaded: onFirstScreenLoaded
};
if (!window.headLoader) {
    window.headLoader = {
        onReady: function (fn) { return fn(); }
    };
    if (typeof window.onHeaderReady === 'function') {
        window.onHeaderReady();
    }
}
var IS_ZOOM_PAGE = /www\.yy\.com\/u\//.test(window.location.href);
if (IS_ZOOM_PAGE) {
    if (!window.statistics) {
        window.statistics = function () {
        };
    }
    else {
        if (window.statistics.init) {
            window.statistics.init();
        }
    }
    if (!window.statisticsEvent) {
        window.statisticsEvent = {
            set: function () {
            }
        };
    }
    else {
        if (window.statisticsEvent.init) {
            window.statisticsEvent.init();
        }
    }
}
